import { render } from "./Detail.vue?vue&type=template&id=41f29ae4&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=41f29ae4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41f29ae4"

export default script